export const getRoundName = (round) => {
  const roundName = round?.roundName?.trim?.();
  return roundName
    ? `Round ${roundName}`
    : `Round ${round?.number ?? ""}${round?.subRound ?? ""}`;
};
